import type { UnreadCount } from '@/services/notification/type';
import { create } from 'zustand';
import { fetchUnreadCount } from '@/services/notification';

interface NotificationUnreadCounts {
  unreadCount: number;
  updateUnread: number;
  forYouUnread: number;
}

interface NotificationStore extends NotificationUnreadCounts {
  loadUnreadCount: () => Promise<void>;
  clearUnreadCounts: () => void;
}

const emptyUnreadCounts: NotificationUnreadCounts = {
  unreadCount: 0,
  updateUnread: 0,
  forYouUnread: 0,
};

let loadUnreadCountPromise: Promise<void> | null = null;

function normalizeUnreadCounts(data?: UnreadCount | null): NotificationUnreadCounts {
  return {
    unreadCount: data?.count ?? 0,
    updateUnread: data?.update ?? 0,
    forYouUnread: data?.forYou ?? 0,
  };
}

export const useNotificationStore = create<NotificationStore>(set => ({
  ...emptyUnreadCounts,

  loadUnreadCount: async () => {
    if (loadUnreadCountPromise) {
      return loadUnreadCountPromise;
    }

    loadUnreadCountPromise = (async () => {
      try {
        const result = await fetchUnreadCount();
        set(normalizeUnreadCounts(result?.data));
      } catch {
        // 静默失败，保留当前未读数，避免刷新失败导致入口状态跳变
      } finally {
        loadUnreadCountPromise = null;
      }
    })();

    return loadUnreadCountPromise;
  },

  clearUnreadCounts: () => {
    set(emptyUnreadCounts);
  },
}));
